import React from 'react';
import PropTypes from 'prop-types';
import { content as ContentPropType } from 'lib/CustomPropTypes';
import Bacon from 'components/packages/Bacon';
import { appendTracking, appendTrackingUnibrow } from '../utility';

const MsnbcDailyAuthors = ({
  content,
  title,
  vertical,
}) => {
  const modifiedContent = { ...content };
  const trackingType = 'pkgColumnist';

  // Append tracking to content and unibrow links
  modifiedContent.items.forEach((row) => {
    const {
      computedValues, item, metadata, related, type,
    } = row;
    if (typeof computedValues.url !== 'undefined') {
      computedValues.url = appendTracking(computedValues.url, trackingType);
    }
    if (typeof computedValues.unibrow !== 'undefined') {
      computedValues.unibrow = appendTrackingUnibrow(computedValues.unibrow, trackingType);
    }
    return {
      computedValues, item, metadata, related, type,
    };
  });

  return (
    <div className="msnbcDaily__authors">
      <div className="msnbcDaily__header-border" />
      <h3 className="msnbcDaily__authors-title">
        {title}
      </h3>
      <Bacon
        content={modifiedContent}
        vertical={vertical}
      />
    </div>
  );
};

MsnbcDailyAuthors.propTypes = {
  content: PropTypes.shape({
    cardType: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(ContentPropType).isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
};

export { MsnbcDailyAuthors };
